/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Shot_Source_TitleInputs */

const en_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Change Data`)
};

const fr_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données de changement de tir`)
};

const de_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schusswechseldaten`)
};

const it_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati sulla modifica dello scatto`)
};

const ru_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные об изменении удара`)
};

const es_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de cambio de disparo`)
};

const zh_cn2_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投篮变化数据`)
};

const ja_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット変更データ`)
};

const hi_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन डेटा`)
};

const pt_pt2_ad_shot_source_title = /** @type {(inputs: Ad_Shot_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de alteração de tiro`)
};

/**
* | output |
* | --- |
* | "Shot Change Data" |
*
* @param {Ad_Shot_Source_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_title = /** @type {((inputs?: Ad_Shot_Source_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_shot_source_title(inputs)
	if (locale === "de") return de_ad_shot_source_title(inputs)
	if (locale === "it") return it_ad_shot_source_title(inputs)
	if (locale === "ru") return ru_ad_shot_source_title(inputs)
	if (locale === "es") return es_ad_shot_source_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_shot_source_title(inputs)
	if (locale === "ja") return ja_ad_shot_source_title(inputs)
	if (locale === "hi") return hi_ad_shot_source_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_shot_source_title(inputs)
	return en_ad_shot_source_title(inputs)
});